import type { ISiteFloor } from '../../interfaces/IScheduler.js';

// ---------------------------------------------------------------------------
// The areas a task covers, as one line: `3F · 4F · 8 area(s) selected`.
//
// Two surfaces say it — the commit review's Areas row and the drawer's promise
// block — and they must agree word for word, since the second is the read-only
// form of the first.
// ---------------------------------------------------------------------------

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** The floors a task's areas lie on, by name, in the catalog's order. */
export function areaFloorNames(areaIds: readonly string[], floors: readonly ISiteFloor[]): string[] {
  const chosen = new Set(areaIds);
  return floors.filter((floor) => floor.zones.some((zone) => chosen.has(zone.id))).map((floor) => floor.name);
}

export function areaSummary(
  areaIds: readonly string[],
  floors: readonly ISiteFloor[],
  t: Translate,
): string {
  const names = areaFloorNames(areaIds, floors);
  const count = t('scheduler.panel.locations.assignedCount', { total: areaIds.length });
  // A catalog that hasn't loaded (or areas from another site) names no floors —
  // the count alone is still true.
  return names.length > 0 ? `${names.join(' · ')} · ${count}` : count;
}
